import type { FunctionComponent } from "react";
import {
	type IPost,
	PostStatus,
} from "../../../../types/models/post.models.types";
import { InstagramEmbed } from "react-social-media-embed";

interface IProps {
	post: IPost;
}

export const CampaignPostMediaBrandPartial: FunctionComponent<IProps> = ({
	post,
}) => {
	switch (post.postStatus.status) {
		case PostStatus.draft:
		case PostStatus.draftApproved:
		case PostStatus.draftRejected:
			return (
				<>
					<div className="relative flex justify-center items-center w-full">
						{/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
						<video
							controls={true}
							src={post.draftAsset?.url}
							className="w-full h-auto aspect-[9/16] cursor-pointer object-cover"
						/>
					</div>

					<div className="flex flex-col px-6 pt-5 pb-8 w-full font-semibold text-base">
						<p>{post.draftDescription}</p>
					</div>
				</>
			);
		case PostStatus.post:
		case PostStatus.postApproved:
		case PostStatus.postRejected:
		case PostStatus.disqualify:
		case PostStatus.flagged:
		case PostStatus.flaggedReview:
			if (!post.liveUrl) {
				throw new Error("live url not found");
			}
			return (
				<>
					<div className="overflow-hidden">
						<InstagramEmbed
							url={post.liveUrl}
							height={650}
							width={"100%"}
							captioned={true}
						/>
					</div>
				</>
			);
	}
};
